import _ from 'lodash'
import React, { useState, useEffect } from 'react'
import { Button, FormControl, FormGroup, Label } from 'react-bootstrap'

import i18n from 'live/services/i18n'

import { SwitchButtonWithTrigger } from 'plugin-generic-components/shared/components/components'
import { PresenterProps } from 'plugin-codaf-risk-ext-bowtie/shared/UpdateModeFrontAPI'

import { Escalation, RemoveEscalation, UpdateMode, UpdateModeContainer } from './style'

type ILiveApiBarrierConfig = {
    systemId: string
}

type IEditorEscalation = import('plugin-codaf-risk-ext-bowtie/types').IEscalationFactor & { uid: string }

export const QuantitativeLiveApi: React.FC<PresenterProps> = ({ barrierPointers, onChanged, editable }) => {
    const [switchEscalation, setSwitchEscalation] = useState<boolean>(barrierPointers[0].escalations.length > 0)

    const handleSystemIdChange = (e: React.FormEvent<FormControl>): void => {
        if (barrierPointers[0]?.updateModeJsonConfig) {
            barrierPointers.forEach(
                el =>
                    ((el.updateModeJsonConfig as ILiveApiBarrierConfig).systemId = (e.target as HTMLInputElement).value)
            )
        } else {
            const data: ILiveApiBarrierConfig = {
                systemId: (e.target as HTMLInputElement).value
            }
            barrierPointers.forEach(el => (el.updateModeJsonConfig = data))
        }
        onChanged()
    }

    const deleteAllScalations = (): void => {
        const newArray = []
        barrierPointers.forEach(el => (el.escalations = [...newArray]))
        onChanged()
    }

    const confirmRemoveAllEscalations = (): void => {
        if (switchEscalation && barrierPointers[0].escalations.length > 0) {
            deleteAllScalations()
        }
    }

    const onDeleteEscalationRequest = (escalationEdit: IEditorEscalation): void => {
        if (barrierPointers[0].root) {
            const newArray = (barrierPointers[0].escalations as IEditorEscalation[]).filter(e => {
                if (e.id) {
                    return e.id !== escalationEdit.id
                } else {
                    return e.uid !== escalationEdit.uid
                }
            })
            barrierPointers[0].escalations = [...newArray]
        } else {
            barrierPointers.forEach(bar => {
                const newArray = (bar.escalations as IEditorEscalation[]).filter(e => {
                    if (e.id) {
                        return e.id !== escalationEdit.id
                    } else {
                        return e.uid !== escalationEdit.uid
                    }
                })
                bar.escalations = [...newArray]
            })
        }

        onChanged()
    }

    const handleAddEscalationFactor = (): void => {
        // const recursiveArrayOfBarrier = handleGetRecursiveSearch(item[0] as IEditorBarrier)

        const escalationToAdd: IEditorEscalation = {
            id: null,
            uid: _.uniqueId(),
            name: null,
            barriers: []
            // getFather: item[0] as IEditorBarrier
        }

        if (barrierPointers[0].root) {
            if (!barrierPointers[0].escalations.length) {
                barrierPointers[0].escalations = [escalationToAdd]
            } else {
                barrierPointers[0].escalations = [...barrierPointers[0].escalations, escalationToAdd]
            }
        } else {
            if (barrierPointers[0].id) {
                barrierPointers.forEach(bar => {
                    if (!bar.escalations.length) {
                        bar.escalations = [escalationToAdd]
                    } else {
                        bar.escalations = [...bar.escalations, escalationToAdd]
                    }
                })
            } else {
                if (!barrierPointers[0].escalations.length) {
                    barrierPointers[0].escalations = [escalationToAdd]
                } else {
                    barrierPointers[0].escalations = [...barrierPointers[0].escalations, escalationToAdd]
                }
            }
        }

        onChanged()
    }
    const escalationsFields = barrierPointers[0].escalations.map((escalation, index) => {
        return (
            <Escalation key={index}>
                <FormGroup validationState={barrierPointers[0].escalations[index].name ? 'success' : 'error'}>
                    <Label required className="control-label">
                        {i18n('Escalation Factor')} #{index + 1}
                    </Label>
                    <FormControl
                        readOnly={!editable}
                        type="text"
                        componentClass="textarea"
                        onChange={e => {
                            barrierPointers.forEach(
                                el => (el.escalations[index].name = (e.target as HTMLInputElement).value)
                            )
                            onChanged()
                        }}
                        id="barrierEditor-barrierEditModal-field-lopaScaling-escalationFactor"
                        value={escalation.name}
                    />
                </FormGroup>

                {editable && (
                    <RemoveEscalation>
                        {barrierPointers[0].escalations.length > 1 && (
                            <button onClick={() => onDeleteEscalationRequest(escalation as IEditorEscalation)}>
                                <i className="far fa-trash-alt"></i>
                            </button>
                        )}
                    </RemoveEscalation>
                )}
            </Escalation>
        )
    })

    return (
        <UpdateModeContainer>
            <FormGroup
                validationState={
                    !(barrierPointers[0].updateModeJsonConfig as ILiveApiBarrierConfig)?.systemId ? 'error' : 'success'
                }
            >
                <Label required className="control-label">
                    <span>{i18n('LIVE Event ID')}</span> <div className="required-star">*</div>
                </Label>
                <FormControl
                    readOnly={!editable}
                    type="text"
                    onChange={handleSystemIdChange}
                    id="barrierEditor-barrierEditModal-field-liveEventId"
                    value={(barrierPointers[0].updateModeJsonConfig as ILiveApiBarrierConfig)?.systemId}
                />
            </FormGroup>
            <UpdateMode>
                <SwitchButtonWithTrigger
                    id={'escalationFactor'}
                    label={i18n('Escalation Factors')}
                    value={switchEscalation}
                    onChange={setSwitchEscalation}
                    disabled={!editable}
                    optionalFunctionTrigger={confirmRemoveAllEscalations}
                />

                {switchEscalation && (
                    <>
                        <div className="escalations">{escalationsFields}</div>
                        <Button
                            disabled={!editable}
                            className="add-escalation-button"
                            bsStyle="primary"
                            onClick={() => handleAddEscalationFactor()}
                        >
                            <i className="fas fa-plus"></i> {i18n('add escalation')}
                        </Button>
                    </>
                )}
            </UpdateMode>
        </UpdateModeContainer>
    )
}
